export const MAX_MILEAGE = 350_000;
